import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';
import { TabViewModule, CalendarModule, DataTableModule, MenubarModule, ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { TaskModule } from 'app/task/task.module';

import { SystemDivisionComponent } from './systemdivision/system-division.component';
import { ClientHeaderService } from './client-header.service';
import { ClientHeaderComponent } from './client-header.component';
import { OrganisationDetailsComponent } from './organisationdetails/organisation-details.component';
import { ReviewCompanyComponent } from './reviewcompany/review-company.component';
import { RiskProfileComponent } from './riskprofile/risk-profile.component';
import { OffboardClientComponent } from './offboardclient/offboard-client.component';

@NgModule({
    declarations: [
        ClientHeaderComponent,
        OrganisationDetailsComponent,
        ReviewCompanyComponent,
        RiskProfileComponent,
        OffboardClientComponent,
        SystemDivisionComponent
    ],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        TaskModule
    ],
    providers: [
        ClientHeaderService,
        ConfirmationService
    ],
    entryComponents: [
        OrganisationDetailsComponent,
        ReviewCompanyComponent,
        RiskProfileComponent,
        OffboardClientComponent,
        SystemDivisionComponent
    ],
    exports: [
        ClientHeaderComponent
    ]
})

/**
 * Main module for the client header management.
*/
export class ClientHeaderModule { }



// WEBPACK FOOTER //
// ./src/app/clients/client/header/client-header.module.ts